<template>
  <div class="row">
    <div class="col-3 d-sm-none">
      <div class="oval">
        &nbsp;
      </div>
    </div>
    <div class="col-6 d-sm-none text-center">
      <div class="logo">
        <img src="@/assets/logos/logo-green@2x.png" class="logo-image">
      </div>
    </div>
    <div class="col-3 d-sm-none">
      <a :href="platformUrl+'login'">
        <div class="user">
          <img src="@/assets/icons/icon-user.svg">
        </div>
      </a>
    </div>

    <div class="col-11 d-none d-sm-block" style="max-height: 180px;">
      <div class="oval">
      </div>
      <div class="logo">
        <img src="@/assets/logos/logo-green@2x.png" class="logo-image">
      </div>
    </div>
    <div class="col-1 d-none d-sm-block">
      <a :href="platformUrl+'login'">
        <div class="user">
          <img src="@/assets/icons/icon-user.svg">
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    platformUrl: {
      type: String,
      default: 'https://plataforma.abacolatam.com/'
    }
  }
}
</script>

<style>
.oval {
  height: 260px;
  width: 45%;
  opacity: 0.29;
  background-color: #F3D7BD;
  left: -97px;
  position: relative;
  top: -110px;
  border-radius: 100%;
}
.logo {
  margin-top: 29px;
  margin-bottom: 50px;
  top: 0px;
  width: 15%;
  position: absolute;
}
.logo-image {
  width: 100%;
}
.user {
  margin-top: 42px;
  height: 40px;
  width: 40px;
  background-color: #00C087;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 756px) {
  .oval {
    height: 115px;
    width: 206px;
    opacity: 0.29;
    background-color: #F3D7BD;
    left: -97px;
    position: relative;
    top: -70px;
    border-radius: 80%;
  }

  .logo {
    margin-top: 29px;
    margin-bottom: 24px;
    top: 0px;
    left: 0px;
    width: unset;
    position: relative;
  }

  .logo-image {
    width: 80%;
    max-width: 85%;
  }
}
@media (max-width: 756px) and (min-width: 576px){
  .logo {
    top: 0px;
    width: 15%;
    position: absolute;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue